if (document.getElementById('products') !== null) {
    Array.prototype.forEach.call(
        document.querySelectorAll('#products span[itemprop="description"]'),
        (e) => (e.style = 'display: none;')
    );
}
